import Page from "@/components/pages/inventory/sales-order/logistic/page";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";

const searchSchema = z.object({
  salesOrderId: z.string().optional(),
  type: z.enum(["edit", "view", "add"]).optional(),
  status: z
    .enum([
      "ALL",
      "NOT_STARTED",
      "PICKED_UP",
      "IN_TRANSIT",
      "CUSTOMS_CLEARANCE",
      "OUT_FOR_DELIVERY",
      "DELIVERED",
      "DELIVERY_FAILED",
      "RETURNED"
    ])
    .catch("NOT_STARTED")
    .default("NOT_STARTED"),
  needRefresh: z.boolean().optional(),
  // Date filtering parameters
  dateRangeStart: z.string().optional(),
  dateRangeEnd: z.string().optional(),
  dateFilter: z.enum(["today", "week", "month", "custom"]).optional(),
  // Pagination parameters
  page: z.number().min(1).optional().default(1),
  limit: z.number().min(10).max(100).optional().default(20),
  // Sorting parameters
  sortBy: z.string().optional(),
  sortOrder: z.enum(["asc", "desc"]).optional().default("desc"),
  // Filter parameters
  customerId: z.string().optional(),
  courier: z.string().optional(),
  trackingNumber: z.string().optional(),
  destination: z.string().optional(),
  // Bulk operation parameters
  selectedOrders: z.array(z.string()).optional(),
  bulkAction: z.enum(["status_update", "export", "assign_courier"]).optional(),
  modalSize: z.string().optional(),
  modalType: z.enum([
    'warehouse',
    'logistic',
    'payment',
    'overview',
    'app'
  ]).optional(),
});

export const Route = createFileRoute(
  "/_app/inventory/sales-order/_modal/logistic",
)({
  component: Page,
  validateSearch: zodValidator(searchSchema),
});
